const terms = ({website}) => website.terms;
const refundPolicy = ({website}) => website.refundPolicy;
const websiteErrors = ({website}) => website.errors;

export const selectors = {
    terms,
    refundPolicy,
    websiteErrors
};
